














































































































































































































































import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import { IPagination } from "@/model/component.model";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";
import Modal from "../shared/modal/Modal.vue";
import Pagination from "../shared/Pagination.vue";
import { ShipmentService } from "@/services/ShipmentService";
import { getTenantId } from "@/services/AuthService";
import { alertDangerReason } from "@/services/Helpers";

@Component({
  validations() {
    return {
      selectedTemplate: {
        name: {
          required
        }
      }
    };
  },
  components: {
    MbeModal: Modal,
    Pagination: Pagination,
    DecimalNumber
  }
})
export default class DefaultPackaging extends Vue {
  showPackModal = false;
  packagingTemplates: any[] = [];
  selectedTemplate: any = {};
  searchParams: any = {
    search: "",
    orderField: "",
    orderDirection: "asc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };

  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };

  created() {
    this.search();
  }
  editTemplate(template: any) {
    this.selectedTemplate = JSON.parse(JSON.stringify(template));
    this.showPackModal = true;
  }
  deleteTemplate(template: any) {
    ShipmentService.prototype
      .deleteShipmentTemplate(
        template,
        this.$store.getters["customer/info"].customerId,
        this.$store.getters.user.username
      )
      .then(res => {
        this.search();
      })
      .catch(err => {
        this.$alerts.danger(err.response.data.message);
      });
  }
  onCreatedButtonClick() {
    this.selectedTemplate = {
      name: "",
      weight: 0,
      depth: 0,
      width: 0,
      height: 0,
      content: ""
    };
    this.showPackModal = true;
  }
  saveTemplate(isNew: boolean) {
    if (isNew) {
      const template = {
        tenantId: getTenantId(),
        customerId: this.$store.getters["customer/info"].customerId,
        username: this.$store.getters.user.username,
        weight: this.selectedTemplate.weight,
        depth: this.selectedTemplate.depth,
        width: this.selectedTemplate.width,
        height: this.selectedTemplate.height,
        content: this.selectedTemplate.content,
        name: this.selectedTemplate.name
      };
      ShipmentService.prototype
        .createShipmentTemplate(
          template,
          this.$store.getters["customer/info"].customerId,
          this.$store.getters.user.username
        )
        .then(res => {
          this.search();
          this.togglePackModal(false);
        })
        .catch(err => {
          this.$alerts.danger(err.response.data.message);
        });
    } else {
      const template = {
        tenantId: getTenantId(),
        customerId: this.$store.getters["customer/info"].customerId,
        username: this.$store.getters.user.username,
        weight: this.selectedTemplate.weight,
        depth: this.selectedTemplate.depth,
        width: this.selectedTemplate.width,
        height: this.selectedTemplate.height,
        content: this.selectedTemplate.content,
        name: this.selectedTemplate.name,
        shipmentTemplateId: this.selectedTemplate.shipmentTemplateId
      };
      ShipmentService.prototype
        .updateShipmentTemplate(
          template,
          this.$store.getters["customer/info"].customerId,
          this.$store.getters.user.username
        )
        .then(res => {
          this.search();
          this.togglePackModal(false);
        })
        .catch(err => {
          this.$alerts.danger(err.response.data.message);
        });
    }
  }

  togglePackModal(showModal: boolean) {
    this.showPackModal = showModal;
  }
  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.searchParams.page = pagination.currentPage - 1;
    this.searchParams.pageSize = pagination.perPage;
    this.search();
  }
  search() {
    ShipmentService.prototype
      .searchShipmentTemplates(
        this.searchParams,
        this.$store.getters["customer/info"].customerId,
        this.$store.getters.user.username
      )
      .then((res: any) => {
        this.packagingTemplates = res.templates;
        this.pagination.totalElements = res.searchParams.totalElements;
        this.searchParams.totalElements = res.searchParams.totalElements;
        this.searchParams.totalPages = res.searchParams.totalPages;
        this.searchParams.numberOfElements = res.searchParams.numberOfElements;
        this.searchParams.page = res.searchParams.page;
        this.searchParams.pageSize = res.searchParams.pageSize;
      })
      .catch(err => {
        this.$snotify.error(err.response.data.message);
      });
  }
}
